import { getCurrentGruserSlice } from './grusers';
export const getLayout = (state, gruser)=>{
    var _getCurrentGruserSlice;
    return (_getCurrentGruserSlice = getCurrentGruserSlice(state, gruser)) === null || _getCurrentGruserSlice === void 0 ? void 0 : _getCurrentGruserSlice.layout;
};
export const getVersion = (state, gruser)=>{
    var _getLayout;
    return (_getLayout = getLayout(state, gruser)) === null || _getLayout === void 0 ? void 0 : _getLayout.version;
};
export const getZones = (state, gruser)=>{
    var _getLayout;
    return ((_getLayout = getLayout(state, gruser)) === null || _getLayout === void 0 ? void 0 : _getLayout.zones) || {};
};
